import axios from 'axios';
import { type UploadInsurerData } from '../../../types/BaselineMeasurements';

const uploadInsurerEmployeeData = async ({ comparisonId, connectionId, employeeData }: UploadInsurerData) => {
  return axios.post(`/baseline-measurements/insurers-data/employees`, {
    comparisonId: comparisonId,
    connectionId: connectionId,
    employeeData: employeeData,
  });
};

export const insurerDataService = {
  uploadInsurerEmployeeData,
};
